/* @flow */

import type { VenueResult } from 'search/types';

import { trackEvent } from 'utils/analytics';

export function trackBrowsedPreviewImages(
  viewedImagesCount: number,
  { id, preview_images: images = [] }: VenueResult
) {
  trackEvent('Browsed Preview Images', {
    'Viewed Images Count': viewedImagesCount,
    'Images Count': images.length,
    'Venue ID': id
  });
}
